import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";
const initialState = {
  groomingSelfiesList: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_GROOMING_SELFIES_LIST:
      return setGroomingSelfiesList(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_GROOMING_SELFIES:
      return setActiveFilters(state, action);
    case ActionTypes.RESET_STATE_GROOMING_SELFIES:
      return resetGroomingSelfies(state, action);
    default:
      return state;
  }
}

const setGroomingSelfiesList = (state, action) => {
  return {
    ...state,
    groomingSelfiesList: action.payload, //getPath(action.payload, "", []),
  };
};

const resetGroomingSelfies = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
